"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  // APP ACTIONS
  SET_EDITOR_LOADED: null,
  SET_BODY_EDITOR_ACTIVE: null,
  // AUTH ACTIONS
  SET_AUTH: null,
  SET_COMPOSER_COMPOSITION_ID: null,
  SET_COMPOSITION_FORCED_READ_ONLY: null,
  // UI ACTIONS
  DISMISS_SHARE_MODAL: null,
  SHOW_SHARE_MODAL: null,
  DISMISS_GOOGLE_AUTH_MODAL: null,
  SHOW_GOOGLE_AUTH_MODAL: null,
  SHOW_GOOGLE_AUTH_ERROR: null,
  DISMISS_GOOGLE_AUTH_ERROR: null,
  DISMISS_GOOGLE_DOC_IMPORT_ERROR: null,
  DISMISS_GOOGLE_DOC_IMPORT_IMAGE_UPLOAD_ERROR: null,
  SHOW_REVISIONS: null,
  HIDE_REVISIONS: null,
  SHOW_GOOGLE_DOCS_PICKER: null,
  HIDE_GOOGLE_DOCS_PICKER: null,
  SHOW_GOOGLE_ACCOUNT_SWITCHER: null,
  HIDE_GOOGLE_ACCOUNT_SWITCHER: null,
  // COMPOSITION ACTIONS
  FETCH_COMPOSITION_PENDING: null,
  FETCH_COMPOSITION_FAILED: null,
  FETCH_FULL_COMPOSITION_SUCCEEDED: null,
  // SAVE ACTIONS
  SET_INITIAL_CONTENT: null,
  SET_INITIAL_TITLE: null,
  SET_INITIAL_SUMMARY: null,
  SAVE_NEW_TITLE: null,
  SAVE_NEW_CONTENT: null,
  SAVE_NEW_SUMMARY: null,
  SAVE_COMPOSITION_PENDING: null,
  SAVE_COMPOSITION_SUCCEEDED: null,
  SAVE_COMPOSITION_FAILED: null,
  SAVE_COMPOSITION_FAILED_DISMISSED: null,
  LOCK_EDITING: null,
  LOCK_EDITING_DISMISSED: null,
  HIGHLIGHT_BODY_TEXT: null,
  REMOVE_HIGHLIGHTED_BODY_TEXT: null,
  HIGHLIGHT_TITLE_TEXT: null,
  REMOVE_HIGHLIGHTED_TITLE_TEXT: null,
  HIGHLIGHT_SUMMARY_TEXT: null,
  REMOVE_HIGHLIGHTED_SUMMARY_TEXT: null,
  SAVE_COMPOSITION_FAILED_BECAUSE_OF_LOCK: null,
  SAVE_COMPOSITION_FAILED_BECAUSE_OF_SCOPE: null,
  CONVERT_POST_FAILED_BECAUSE_OF_CONFLICT: null,
  CLEAR_CONVERT_CONFLICT: null,
  ADD_INSERT_TOOLS: null,
  REMOVE_INSERT_TOOLS: null,
  REGISTER_INSERT_TOOLS: null,
  INSERT_IMAGE: null,
  INSERT_VIDEO: null,
  INSERT_CLIP: null,
  INSERT_EMBED: null,
  INSERT_QUESTION_AND_ANSWER: null,
  INSERTABLE_LOADED: null,
  CLIP_LINK_LOADED: null,
  RESTORE_SELECTION_AFTER_MANUAL_FOCUS: null,
  // COMMENTS ACTIONS
  SAVE_COMMENT_PENDING: null,
  SAVE_COMMENT_SUCCEEDED: null,
  SAVE_COMMENT_FAILED: null,
  DELETE_COMMENT_PENDING: null,
  DELETE_COMMENT_SUCCEEDED: null,
  DELETE_COMMENT_FAILED: null,
  // COMMENTS ACTIONS
  CREATE_DUMMY_CONVERSATION: null,
  CREATE_CONVERSATION_PENDING: null,
  CREATE_CONVERSATION_SUCCEEDED: null,
  CREATE_CONVERSATION_FAILED: null,
  REMOVE_EMPTY_CONVERSATIONS: null,
  DELETE_CONVERSATION_PENDING: null,
  DELETE_CONVERSATION_SUCCEEDED: null,
  DELETE_CONVERSATION_FAILED: null,
  DELETE_CONVERSATION_DONE: null,
  DELETE_EMPTY_CONVERSATION: null,
  SELECT_CONVERSATION_BLOCK: null,
  HIDE_ADD_CONVERSATION_BUTTON: null,
  SHOW_ADD_CONVERSATION_BUTTON: null,
  SHOW_CONVERSATION_BLOCKS: null,
  HIDE_CONVERSATION_BLOCKS: null,
  CLOSE_CONVERSATIONS: null,
  OPEN_CONVERSATION: null,
  // USERS ACTIONS
  FETCH_USERS_SUCCEEDED: null,
  FETCH_USERS_FAILED: null,
  // DATA UPDATE ACTIONS TRIGGERED BY REALTIME MESSAGES
  REALTIME_ADD_COMMENT: null,
  REALTIME_ADD_CONVERSATION: null,
  REALTIME_DELETE_COMMENT: null,
  REALTIME_DELETE_CONVERSATION: null,
  REALTIME_UPDATE_COMPOSITION: null,
  // LOCK ACTIONS
  ACQUIRE_LOCK: null,
  ACQUIRE_LOCK_SUCCEEDED: null,
  ACQUIRE_LOCK_FAILED: null,
  LOCK_TOAST_DISMISSED: null,
  CLEAR_LOCK: null,
  CLEAR_LOCK_SUCCEEDED: null,
  CLEAR_LOCK_FAILED: null,
  END_REALTIME_UPDATE_TRANSITION: null,
  // TOAST ACTIONS
  ADD_TOAST: null,
  REMOVE_TOAST: null,
  // CLIPS ACTIONS
  FETCH_CLIPS_PENDING: null,
  FETCH_CLIPS_SUCCEEDED: null,
  FETCH_CLIPS_FAILED: null,
  DELETE_CLIP: null,
  // DATA UPDATE ACTIONS TRIGGERED BY REALTIME PRESENCE CHANGES
  REALTIME_ADD_USER: null,
  REALTIME_REMOVE_USER: null,
  REALTIME_UPDATE_LOCK: null,
  REALTIME_UPDATE_LOCK_REQUEST: null,
  PASS_LOCK_REQUEST: null,
  REQUEST_LOCK_SUCCEEDED: null,
  REALTIME_UPDATE_LOCK_REQUEST_REJECTED: null,
  CHANGE_CLIPS_TYPE: null,
  CHANGE_CLIPS_SEARCH: null,
  CHANGE_CLIPS_AUTHOR: null,
  FETCH_PAGES_PENDING: null,
  FETCH_PAGES_SUCCEEDED: null,
  FETCH_PAGES_FAILED: null,
  // GOOGLE DOCS ACTIONS
  FETCH_GOOGLE_ACCESS_TOKEN_PENDING: null,
  FETCH_GOOGLE_ACCESS_TOKEN_SUCCEEDED: null,
  FETCH_GOOGLE_ACCESS_TOKEN_FAILED: null,
  IMPORT_GOOGLE_DOC_PENDING: null,
  IMPORT_GOOGLE_DOC_SUCCEEDED: null,
  IMPORT_GOOGLE_DOC_FAILED: null,
  IMPORT_GOOGLE_DOC_IMAGE_UPLOAD_FAILED: null,
  FETCH_GOOGLE_ACCOUNTS_PENDING: null,
  FETCH_GOOGLE_ACCOUNTS_SUCCEEDED: null,
  FETCH_GOOGLE_ACCOUNTS_FAILED: null,
  UPDATE_GOOGLE_ACCOUNT: null,
  // REVISIONS ACTIONS
  FETCH_REVISIONS_PENDING: null,
  FETCH_REVISIONS_SUCCEEDED: null,
  FETCH_REVISIONS_FAILED: null,
  DISMISS_FETCH_REVISIONS_FAILED_ERROR: null,
  REVISION_REVERT_PENDING: null,
  REVISION_REVERT_SUCCEEDED: null,
  REVISION_REVERT_FAILED: null,
  DISMISS_REVERT_FAILED_ERROR: null,
  // USER ATTRIBUTES ACTIONS
  FETCH_USER_ATTRIBUTES_PENDING: null,
  FETCH_USER_ATTRIBUTES_SUCCEEDED: null,
  FETCH_USER_ATTRIBUTES_FAILED: null,
  UPDATE_USER_ATTRIBUTE_PENDING: null,
  UPDATE_USER_ATTRIBUTE_SUCCEEDED: null,
  UPDATE_USER_ATTRIBUTE_FAILED: null
});

exports.default = _default;
module.exports = exports.default;